import * as React from 'react'

import { cn } from '../../lib/utils'

function Input({ className, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      data-slot="input"
      className={cn(
        'border-border bg-bg-elev text-fg h-9 w-full min-w-0 rounded-md border px-3 text-base transition-colors duration-100 ease-out outline-none',
        'placeholder:text-fg-subtle',
        'focus-visible:outline-accent focus-visible:outline-2 focus-visible:outline-offset-1',
        'disabled:pointer-events-none disabled:opacity-50',
        'aria-invalid:border-err aria-invalid:focus-visible:outline-err',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
